import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {AffectionAutocompleteComponent} from './affection.autocomplete.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [AffectionAutocompleteComponent],
  exports: [AffectionAutocompleteComponent]
})
export class AffectionAutocompleteFormModule {
}

